<template>
  <ContentWrap>
    <el-form :inline="true" :model="query" class="-mb-15px">
      <el-form-item label="活动ID">
        <el-input v-model="query.activityId" clearable class="!w-140px" placeholder="可选" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="load"><Icon icon="ep:search" />查询</el-button>
        <el-button @click="exportExcel" :loading="exporting"><Icon icon="ep:download" />导出订单</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap v-loading="loading">
    <el-row :gutter="16">
      <el-col :span="6">
        <el-statistic title="批次数" :value="summary.batchCount || 0" />
      </el-col>
      <el-col :span="6">
        <el-statistic title="批次运费合计(元)" :value="Number(summary.batchFeeTotal || 0)" :precision="2" />
      </el-col>
      <el-col :span="6">
        <el-statistic title="已计提佣金笔数" :value="summary.commissionCount || 0" />
      </el-col>
      <el-col :span="6">
        <el-statistic
          title="已计提佣金合计(元)"
          :value="(summary.commissionAmountTotalFen || 0) / 100"
          :precision="2"
        />
      </el-col>
    </el-row>
    <el-alert
      class="mt-16px"
      type="info"
      :closable="false"
      title="司机配送费线下结算。整单退款会从批次解绑并重算运费；团长佣金冲销后以佣金状态为准。"
    />
    <el-tabs class="mt-16px">
      <el-tab-pane label="批次明细">
        <el-table :data="batches" stripe>
          <el-table-column prop="batchNo" label="批次号" min-width="140" />
          <el-table-column prop="activityId" label="活动ID" width="100" />
          <el-table-column prop="status" label="状态" width="110" />
          <el-table-column prop="orderCount" label="订单数" width="90" />
          <el-table-column prop="batchFee" label="运费(元)" width="110" />
          <el-table-column prop="abnormalReason" label="异常" min-width="140" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="160" />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="订单明细">
        <el-table :data="orders" stripe>
          <el-table-column prop="tradeOrderNo" label="订单号" min-width="160" />
          <el-table-column prop="activityId" label="活动ID" width="100" />
          <el-table-column prop="batchNo" label="批次号" min-width="140" />
          <el-table-column prop="deliveryFeeShare" label="分摊运费" width="110" />
          <el-table-column prop="commissionAmount" label="佣金(分)" width="110" />
          <el-table-column prop="commissionStatus" label="佣金状态" width="100" />
          <el-table-column prop="refundStatus" label="退款状态" width="100" />
          <el-table-column prop="createTime" label="创建时间" min-width="160" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </ContentWrap>
</template>

<script setup lang="ts">
import * as Api from '@/api/merchant/groupbuy'

defineOptions({ name: 'MerchantGroupbuyReport' })

const loading = ref(false)
const exporting = ref(false)
const query = reactive({ activityId: undefined as string | undefined })
const summary = ref<Api.GroupbuyReportSummaryVO>({})
const batches = ref<any[]>([])
const orders = ref<any[]>([])

const queryParams = () => {
  const params: { activityId?: number } = {}
  if (query.activityId) {
    params.activityId = Number(query.activityId)
  }
  return params
}

const load = async () => {
  loading.value = true
  try {
    const params = queryParams()
    summary.value = (await Api.getReportSummary(params)) || {}
    batches.value = (await Api.getReportBatches(params)) || []
    orders.value = (await Api.getReportOrders(params)) || []
  } finally {
    loading.value = false
  }
}

const exportExcel = async () => {
  exporting.value = true
  try {
    await Api.exportReportExcel(queryParams())
  } finally {
    exporting.value = false
  }
}

onMounted(load)
</script>
